import React from 'react'
import { useTranslation } from 'react-i18next'
import { TitleController, Heading } from '@pandiafi/design-system'

import { DataLoader } from './FrontPageViewDataLoader'
import { BulletinsList } from './components/BulletinsList'

import {
  View,
  Breakpoint,
  ResidentNotifications,
  TaskLinks,
  PendingOperations,
} from 'components'
import DefectNotices from 'components/DefectNotices'

export const FrontPageView: React.FC = () => {
  const { t } = useTranslation(['common', 'titles', 'frontPage'])

  const welcomeText = (firstName: string | null) =>
    `${t('common:hi')} ${firstName}!`

  return (
    <TitleController title={t('titles:home')}>
      <DataLoader>
        {({ user, contract, featureFlags, bulletins, hasMoreBulletins }) => (
          <View>
            <View.Header className="phone:bg-header phone:bg-cover phone:bg-[position:9rem] phone:bg-header-bg-color">
              <div className="h-10" />

              <View.HeaderTitle className="phone:text-common-gray-7">
                {welcomeText(user.firstName)}
              </View.HeaderTitle>

              <Breakpoint show tablet phone>
                <DefectNotices />
                <PendingOperations />
                <ResidentNotifications contractType={contract.contractType} />
              </Breakpoint>
              <Breakpoint hide desktop>
                <TaskLinks featureFlags={featureFlags} contract={contract} />
              </Breakpoint>
            </View.Header>
            <View.Sidebar>
              <Breakpoint show desktop>
                <DefectNotices />
                <PendingOperations />
                <ResidentNotifications
                  contractType={contract.contractType}
                  className="desktop:mt-2"
                />

                <TaskLinks featureFlags={featureFlags} contract={contract} />
              </Breakpoint>
            </View.Sidebar>

            <View.Content>
              <>
                <Heading element="h1" size="xl" semibold className="mb-8">
                  {t('frontPage:header')}
                </Heading>
                <BulletinsList
                  bulletins={bulletins}
                  hasMoreBulletins={hasMoreBulletins}
                />
              </>
            </View.Content>
          </View>
        )}
      </DataLoader>
    </TitleController>
  )
}
